import { HTTP_INTERCEPTORS, HttpClientModule } from '@angular/common/http';
import { NgModule, isDevMode } from '@angular/core';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { MatButtonToggleModule } from '@angular/material/button-toggle';
import { MatDialogModule } from '@angular/material/dialog';
import { MatPaginatorModule } from '@angular/material/paginator';
import { MatRadioModule } from '@angular/material/radio';
import { MatSlideToggleModule } from '@angular/material/slide-toggle';
import { MatSnackBarModule } from '@angular/material/snack-bar';
import { MatTooltipModule } from '@angular/material/tooltip';
import { MatProgressSpinnerModule } from '@angular/material/progress-spinner';
import { BrowserModule } from '@angular/platform-browser';
import { BrowserAnimationsModule } from '@angular/platform-browser/animations';
import { ServiceWorkerModule } from '@angular/service-worker';
import { OKTA_CONFIG, OktaAuthModule } from '@okta/okta-angular';
import { OktaAuth } from '@okta/okta-auth-js';
import { ChartsModule } from 'ng2-charts';
import { environment } from '../environments/environment';
import { AppRoutingModule } from './app-routing.module';
import { AppComponent } from './app.component';
import { FilePreviewComponent } from './components/file-preview/file-preview.component';
import { FileUploadModalComponent } from './components/file-upload-modal/file-upload-modal.component';
import { AppDownloadModalComponent } from './components/header/app-download-modal/app-download-modal.component';
import { HeaderComponent } from './components/header/header.component';
import { LoginComponent } from './components/login/login.component';
import { ErrorComponent } from './components/main/error/error.component';
import { GraphComponent } from './components/main/graph/graph.component';
import { MainComponent } from './components/main/main.component';
import { NotificationDetailsComponent } from './components/main/notifications/notification-details/notification-details.component';
import { NotificationsComponent } from './components/main/notifications/notifications.component';
import { TestComponent } from './components/test/test.component';
import { UploadsComponent } from './components/uploads/uploads.component';
import { DropFileDirective } from './directives/drop-file.directive';
import { AuthErrInterceptor, AuthInterceptor } from './interceptors/auth';
import { AuthPipe } from './pipes/auth.pipe';
import { SafePipe } from './pipes/safe.pipe';
import { AlertService } from './services/alert.service';
import { RetryFileUploadComponent } from './components/retry-file-upload/retry-file-upload.component';
import { MaxcharPipe } from './pipes/maxchar.pipe';
import { RichTextRendererComponent } from './components/rich-text-renderer/rich-text-renderer.component';
import { MatProgressBarModule } from '@angular/material/progress-bar';

console.log('Environment being used : ', environment.env);
const oktaAuth: any = new OktaAuth(environment.oktaConfig);

@NgModule({
  declarations: [
    AppComponent,
    HeaderComponent,
    MainComponent,
    GraphComponent,
    LoginComponent,
    FileUploadModalComponent,
    DropFileDirective,
    FilePreviewComponent,
    SafePipe,
    UploadsComponent,
    AuthPipe,
    NotificationsComponent,
    NotificationDetailsComponent,
    ErrorComponent,
    TestComponent,
    AppDownloadModalComponent,
    RetryFileUploadComponent,
    MaxcharPipe,
    RichTextRendererComponent,
  ],
  imports: [
    BrowserModule,
    AppRoutingModule,
    FormsModule,
    ReactiveFormsModule,
    MatProgressSpinnerModule,
    HttpClientModule,
    MatProgressBarModule,
    ChartsModule,
    MatDialogModule,
    MatSnackBarModule,
    BrowserAnimationsModule,
    MatButtonToggleModule,
    MatPaginatorModule,
    MatRadioModule,
    MatTooltipModule,
    MatSlideToggleModule,
    OktaAuthModule,
    ServiceWorkerModule.register('ngsw-worker.js', {
      enabled: !isDevMode(),
      // Register the ServiceWorker as soon as the application is stable
      // or after 30 seconds (whichever comes first).
      registrationStrategy: 'registerWhenStable:30000',
    }),
  ],
  providers: [
    { provide: HTTP_INTERCEPTORS, useClass: AuthInterceptor, multi: true },
    { provide: HTTP_INTERCEPTORS, useClass: AuthErrInterceptor, multi: true },
    { provide: OKTA_CONFIG, useValue: { oktaAuth } },
    AlertService,
  ],
  bootstrap: [AppComponent],
})
export class AppModule {}